import { func, oneOf } from 'prop-types';
import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

function Badge({ children, variant, color, style, onClick }) {
  const styleColorVariant = `${color}-${variant}`;

  return (
    <span onClick={onClick} className={cn(styles.badge, styles[styleColorVariant], style)}>
      {children}
    </span>
  );
}

Badge.defaultProps = {
  color: 'gray',
  variant: 'outlined'
};

Badge.propTypes = {
  color: oneOf(['blue', 'green', 'gray']),
  variant: oneOf(['outlined', 'contained']),
  onClick: func
};

export default Badge;
